// extracted by mini-css-extract-plugin
export default {"layout":"Delete_layout__38TCk","buttons":"Delete_buttons__reX9N","yes":"Delete_yes__wXiSS","no":"Delete_no__T-q7+"};